import { parseToHex, hexToHSL, hslToHex } from '@barelyhuman/tocolor';

const _process = (percentage, color) => {
  const normalisedHex = parseToHex(color);
  const { h, s, l } = hexToHSL(normalisedHex);
  try {
    return parseToHex(hslToHex(h, s, l + percentage));
  } catch (err) {
    return normalisedHex;
  }
};
function tint(color) {
  return (percentage) => _process(percentage, parseToHex(color));
}

export { tint };
